import SecureLs from "secure-ls"


const ls = typeof window !== 'undefined' ? new SecureLs({encodingType: "aes"}) : {
  get: () => "{}", 
  set: () => {} , 
  removeAll: () => {}, 
}

export default ls 